import { Avatar } from '../common';
import type { Staff } from '../staff/types';

interface Props {
  am: Staff[];
  pm: Staff[];
  // Optional — when given, chips are buttons that open the helper editor (Daily).
  // When omitted, chips render read-only (the Messages day strip reuses the same
  // card without an editor behind it).
  onPick?: (s: Staff) => void;
}

// The On-duty card body — who's rostered AM vs PM for the day, in two labelled
// rows. Chips open the helper editor when interactive; read-only otherwise.
export function OnDutySplit({ am, pm, onPick }: Props) {
  const chip = (s: Staff) => {
    const inner = (
      <>
        <Avatar name={s.name} id={s.id} size={22} />
        <span className="name">{s.name.split(' ')[0]}</span>
      </>
    );
    return onPick ? (
      <button key={s.id} type="button" className="today-name-chip clickable" onClick={() => onPick(s)}>
        {inner}
      </button>
    ) : (
      <span key={s.id} className="today-name-chip">
        {inner}
      </span>
    );
  };
  const row = (label: string, team: Staff[]) => (
    <div className="oc-line">
      <span className="oc-lbl">{label}</span>
      <div className="oc-chips">{team.length ? team.map(chip) : <span className="oc-none">—</span>}</div>
    </div>
  );
  return (
    <div className="oc-stack">
      {row('AM', am)}
      {row('PM', pm)}
    </div>
  );
}
